const handleEMenu = (utagContext: any) => {
    const filterApplyButtons = document.querySelectorAll(
      '.ag-standard-button.ag-filter-apply-panel-button'
    );
    if (
        filterApplyButtons &&
      filterApplyButtons.length > 0
    ) {
      const filterApplyButton: any = filterApplyButtons;
      for (let filterApply of filterApplyButton) {
        filterApply.addEventListener('click', () => handleApplyFilter(utagContext));
      }
    }
  };

const handlePagination = (utagContext: any) => {
  let paginationIcon =
    document
      .querySelectorAll('.ag-paging-button')[0]
      ?.getAttribute('ref_page_event') ?? '';
  if (paginationIcon) {
    utagContext.setRef(paginationIcon);
  }
};

const handleSort = (utagContext: any) => {
  let sortIcon =
    document
      .querySelectorAll(
        '.ag-header-cell-label'
      )[0]
      ?.getAttribute('ref_page_event') ?? '';
  if (sortIcon) {
    utagContext.setRef(sortIcon);
  }
};

const handleApplyFilter = (utagContext: any) => {
  let filterIcon =
    document
      .querySelectorAll('[ref="eMenu"]')[0]
      ?.getAttribute('ref_page_event') ?? '';
  if (filterIcon) {
    utagContext.setRef(filterIcon);
  }
};

export {handleEMenu, handlePagination, handleSort}